import * as detectAutoFill from './detectAutoFill.directive';

export default angular.module('register.components.detectautofill', [
])
  .directive(detectAutoFill.name, detectAutoFill.default)
  .name;



// WEBPACK FOOTER //
// ./components/sign-in/detectAutoFill.module.js